import { AssignmentRules } from './assignmentRules';

export class EditAssignmentRuleInput {
    id: string;
    name?: string;
    negativeRule?: boolean;
    leadType?: string;
    channel?: string;
    brand?: string;
    dealer?: string;
    user?: string;
    active?: boolean;
    origin?: string;
    postalCode?: string;

    constructor(assignmentRule?: AssignmentRules) {
        Object.assign(this, assignmentRule);
    }

    getAssignmentRuleForm(): EditAssignmentRuleInput {
        const editAssignmentRule = new EditAssignmentRuleInput();
        editAssignmentRule.name = this.name;
        editAssignmentRule.negativeRule = this.negativeRule;
        editAssignmentRule.leadType = this.leadType;
        editAssignmentRule.channel = this.channel;
        editAssignmentRule.brand = this.brand;
        editAssignmentRule.dealer = this.dealer;
        editAssignmentRule.user = this.user;
        editAssignmentRule.origin = this.dealer;
        editAssignmentRule.postalCode = this.postalCode;

        return editAssignmentRule;
    }
}
